// src/theme/colors.js

const colors = {
  primary: '#1E9C98',
  secondary: '#054D50',
  tertiary: '#033234',
  white: '#FFFFFF',
  black: '#000000',
  green: '#228b22',
  red: '#FF0000',
  gray: '#808080',

  // Optional specific use cases
  font: {
    primary: '#1E9C98',
    secondary: '#054D50',
    tertiary: '#033234',
    white: '#FFFFFF',
    black: '#000000',
    green: '#228b22',
    red: '#FF0000',
  },

  background: {
    primary: '#1E9C98',
    secondary: '#054D50',
    tertiary: '#033234',
    white: '#FFFFFF',
    black: '#000000',
    green: '#228b22',
    red: '#FF0000',
    gray: '#808080',
  }
};

export default colors;
